/**
 * Resumo dos recursos Meta conectados (conta, pixel, página).
 * SRP: só exibe dados — sem ações de conectar/desconectar.
 */
import React from 'react';
import { AppIcon } from '../../../components/icons/AppIcon';
import { getMetaTokenStatus } from '../types/meta';

export interface MetaConnectionSummaryData {
    accountName?: string;
    pixelName?: string;
    pageName?: string;
    expiresAt?: string;
}

interface MetaConnectionSummaryProps {
    data: MetaConnectionSummaryData;
    formatExpiryDate: (dateString?: string) => string | null;
}

const MetaConnectionSummary: React.FC<MetaConnectionSummaryProps> = ({
    data,
    formatExpiryDate,
}) => {
    const tokenStatus = getMetaTokenStatus(data.expiresAt);
    const expiryClass =
        tokenStatus === 'expired'
            ? 'text-error'
            : tokenStatus === 'expiring'
              ? 'text-warning'
              : 'text-muted';

    return (
        <dl className="space-y-2">
            <div className="flex min-h-11 items-center gap-2 text-sm sm:min-h-0">
                <dt className="flex shrink-0 items-center gap-2 text-secondary">
                    <AppIcon name="briefcase" className="size-4 text-muted" aria-hidden />
                    Conta
                </dt>
                <dd className="min-w-0 truncate font-medium text-default">
                    {data.accountName || '—'}
                </dd>
            </div>

            {data.pixelName ? (
                <div className="flex min-h-11 items-center gap-2 text-sm sm:min-h-0">
                    <dt className="flex shrink-0 items-center gap-2 text-secondary">
                        <AppIcon name="activity" className="size-4 text-muted" aria-hidden />
                        Pixel
                    </dt>
                    <dd className="min-w-0 truncate font-medium text-default">
                        {data.pixelName}
                    </dd>
                </div>
            ) : null}

            {data.pageName ? (
                <div className="flex min-h-11 items-center gap-2 text-sm sm:min-h-0">
                    <dt className="flex shrink-0 items-center gap-2 text-secondary">
                        <AppIcon name="file-text" className="size-4 text-muted" aria-hidden />
                        Página
                    </dt>
                    <dd className="min-w-0 truncate font-medium text-default">
                        {data.pageName}
                    </dd>
                </div>
            ) : null}

            {data.expiresAt ? (
                <div className={`flex items-center gap-2 text-xs ${expiryClass}`}>
                    <AppIcon name="clock" className="size-3" aria-hidden />
                    <span>{formatExpiryDate(data.expiresAt)}</span>
                </div>
            ) : null}
        </dl>
    );
};

export default MetaConnectionSummary;
